import React, { useState, useEffect } from "react";
import {
  Alert,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Label,
  Popover,
  PopoverBody,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import ReactDOMServer from "react-dom/server";
import CurrentPiechart from "./Components/CurrentPiechart";
import MaturityModelProgressBar from "./Components/MaturityModelProgressbar";
import { Input, Collapse, Button } from "reactstrap";
import { deepClone } from "../../utils/copyObject";
import * as actionCreators from "../../modules/actions";
import {
  maturity_model_questions_cats_wise,
  YES_NO_TYPE,
  WEEKS_TYPE,
} from "./data";
import { find, findIndex, groupBy } from "lodash";
import officeCreatedIcon from "../../assets/office_created_icon.svg";
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import * as url from "../../utils/url";
import { IoCalendarClear, IoMenu } from "react-icons/io5";
import axios from "../../axios";
import { toastContainer } from "../../utils/toast";
import { connect } from "react-redux";
import Loading from "../../hoc/Loading/Loading";
import TrendsPlotChart from "./Components/TrendsPlotChart";
import { sortBy } from "lodash";
import Toggle from "react-toggle";
import Select from "react-select/lib/Select";
import { BiDownload } from "react-icons/bi";
import { formatDate } from "../../utils/constants";

function TrendsTab({ user, orgChangeSuccess }) {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startDateDisplay, setStartDateDisplay] = useState(null);
  const [endDateDisplay, setEndDateDisplay] = useState(null);
  const [chartScores, setChartScores] = useState(null);
  const [toggleChecked, setToggleChecked] = useState(false);
  const [selectedBenchmarks, setSelectedBenchmarks] = useState([]);
  const [chartloading, setChartLoading] = useState(true);
  const [openFilterMenu, setOpenFilterMenu] = useState(false);
  const [benchmarkList, setBenchmarkList] = useState([]);
  const [mainBList, setMainBList] = useState([]);

  const [benchmarkScores, setBenchmarkScores] = useState({
    TOTAL: [],
    SC: [],
    TD: [],
    WI: [],
    EC: [],
  });

  const handleBenchmarkApply = (scoresObj, bList, selectedBenchmarks) => {
    const bScores = {
      TOTAL: [],
      SC: [],
      TD: [],
      WI: [],
      EC: [],
    };

    const bNames = {
      TOTAL: [],
      SC: [],
      TD: [],
      WI: [],
      EC: [],
    };

    for (const id of selectedBenchmarks) {
      const benchmarkDoc = bList.find((x) => x._id == id);

      const allBenchmarkDocsOfName = bList.filter(
        (x) => x.industry == benchmarkDoc.industry
      );

      const benchmarkName = benchmarkDoc ? benchmarkDoc.industry : "";

      let total = [],
        sc = [],
        td = [],
        wi = [],
        ec = [];

      // if (benchmarkDoc) {
      //   scBenchmark = benchmarkDoc.group_scores.find(
      //     (x) => x.name == "STRATEGY & COMMITMENT"
      //   ) || { score: 0 };
      //   tdBenchmark = benchmarkDoc.group_scores.find(
      //     (x) => x.name == "TALENT DIVERSITY"
      //   ) || { score: 0 };
      //   wiBenchmark = benchmarkDoc.group_scores.find(
      //     (x) => x.name == "WORKPLACE INCLUSIVITY"
      //   ) || { score: 0 };
      //   ecBenchmark = benchmarkDoc.group_scores.find(
      //     (x) => x.name == "ENGAGEMENT & COMMUNICATION"
      //   ) || { score: 0 };
      //   totalbenchmark = benchmarkDoc.total_score;
      // }

      total = allBenchmarkDocsOfName.map((x) => ({
        name: x.industry,
        score: x.total_score,
        year: moment(x.selectedDate).format("YYYY"),
      }));

      sc = allBenchmarkDocsOfName.map((x) => {
        const scoreObject =
          x.group_scores &&
          x.group_scores.find((x) => x.name == "STRATEGY & COMMITMENT");

        return {
          name: x.industry,
          score: scoreObject ? scoreObject.score : 0,
          year: moment(x.selectedDate).format("YYYY"),
        };
      });
      td = allBenchmarkDocsOfName.map((x) => {
        const scoreObject =
          x.group_scores &&
          x.group_scores.find((x) => x.name == "TALENT DIVERSITY");

        return {
          name: x.industry,
          score: scoreObject ? scoreObject.score : 0,
          year: moment(x.selectedDate).format("YYYY"),
        };
      });
      wi = allBenchmarkDocsOfName.map((x) => {
        const scoreObject =
          x.group_scores &&
          x.group_scores.find((x) => x.name == "WORKPLACE INCLUSIVITY");

        return {
          name: x.industry,
          score: scoreObject ? scoreObject.score : 0,
          year: moment(x.selectedDate).format("YYYY"),
        };
      });
      ec = allBenchmarkDocsOfName.map((x) => {
        const scoreObject =
          x.group_scores &&
          x.group_scores.find((x) => x.name == "ENGAGEMENT & COMMUNICATION");

        return {
          name: x.industry,
          score: scoreObject ? scoreObject.score : 0,
          year: moment(x.selectedDate).format("YYYY"),
          selectedDate:x.selectedDate
        };
      });

      if (scoresObj) {
        if (scoresObj.TOTAL) {
          bScores.TOTAL.push(total);
        }
        if (scoresObj.SC) {
          bScores.SC.push(sc);
        }
        if (scoresObj.TD) {
          bScores.TD.push(td);
        }
        if (scoresObj.WI) {
          bScores.WI.push(wi);
        }
        if (scoresObj.EC) {
          bScores.EC.push(ec);
        }
      }
    }

    setBenchmarkScores(bScores);
  };

  const fetchChartData = (startDate, endDate) => {
    const getBenchmarkIndustryList = () => {
      axios.get(url.getMMBenchmarksList).then(({ data }) => {
        const mainListBenchmarks = data.data;
        setMainBList(mainListBenchmarks);

        // setBenchmarkList(
        //   data.data
        //     .filter(
        //       (x) => 
        //         moment(x.selectedDate).format("YYYY") ===
        //         moment().format("YYYY")
        //     )
        //     .map((x) => ({
        //       label: x.industry,
        //       value: x._id,
        //       isDeleted: x.isDeleted,
        //     }))
        // );

        setOpenFilterMenu(false);
        axios
          .post(url.getChartsDataForMMByDates, {
            startDate: startDate,
            endDate: endDate
              ? endDate
              : toggleChecked
              ? moment().endOf("day")
              : null,
          })
          .then(({ data }) => {
            const totalScore = [];
            const strategyAndCommitment = [];
            const talentDiversity = [];
            const workplaceInclusivity = [];
            const engagementAndCommunication = [];
            setChartLoading(false);
            const sortedByDate = sortBy(data.data, [(x) => x.selectedDate]);

            const first = sortedByDate[0];
            const last = sortedByDate[sortedByDate.length - 1];

            if (first && last) {
              let newBenchmarksArr = []
             const grouped = groupBy(mainListBenchmarks,r => r.industry);

             for (const key in grouped) {
               if (Object.hasOwnProperty.call(grouped, key)) {
                 const element = grouped[key];

                 if(Array.isArray(element)){
                   newBenchmarksArr.push(element[0])
                 }
                 
               }
             }
             setBenchmarkList(newBenchmarksArr.map((x) => ({
              label: x.industry,
              value: x._id,
              isDeleted: x.isDeleted,
            })))
             console.log({grouped})
              if (startDate && endDate) {
                setStartDateDisplay(startDate);
                setEndDateDisplay(endDate);
              } else {
                setStartDateDisplay(first.selectedDate);
                setEndDateDisplay(moment());
                setStartDate(first.selectedDate);
                setEndDate(moment());
              }
            }

            for (const item of data.data) {
              const strategyAndCommitmentScore =
                item.group_scores &&
                item.group_scores.find((x) => x.name == "STRATEGY & COMMITMENT")
                  ? item.group_scores.find(
                      (x) => x.name == "STRATEGY & COMMITMENT"
                    ).score
                  : 0;
              const talentDiversityScore =
                item.group_scores &&
                item.group_scores.find((x) => x.name == "TALENT DIVERSITY")
                  ? item.group_scores.find((x) => x.name == "TALENT DIVERSITY")
                      .score
                  : 0;
              const workplaceInclusivityScore =
                item.group_scores &&
                item.group_scores.find((x) => x.name == "WORKPLACE INCLUSIVITY")
                  ? item.group_scores.find(
                      (x) => x.name == "WORKPLACE INCLUSIVITY"
                    ).score
                  : 0;
              const engagementAndCommunicationScore =
                item.group_scores &&
                item.group_scores.find(
                  (x) => x.name == "ENGAGEMENT & COMMUNICATION"
                )
                  ? item.group_scores.find(
                      (x) => x.name == "ENGAGEMENT & COMMUNICATION"
                    ).score
                  : 0;

              totalScore.push({
                selectedDate: item.selectedDate,
                score: Math.round(item.total_score),
              });

              strategyAndCommitment.push({
                selectedDate: item.selectedDate,
                score: Math.round(strategyAndCommitmentScore),
              });

              talentDiversity.push({
                selectedDate: item.selectedDate,
                score: Math.round(talentDiversityScore),
              });

              workplaceInclusivity.push({
                selectedDate: item.selectedDate,
                score: Math.round(workplaceInclusivityScore),
              });

              engagementAndCommunication.push({
                selectedDate: item.selectedDate,
                score: Math.round(engagementAndCommunicationScore),
              });
            }

            const scoresObj = {
              TOTAL: sortBy(totalScore, [(o) => o.selectedDate]),
              SC: sortBy(strategyAndCommitment, [(o) => o.selectedDate]),
              TD: sortBy(talentDiversity, [(o) => o.selectedDate]),
              WI: sortBy(workplaceInclusivity, [(o) => o.selectedDate]),
              EC: sortBy(engagementAndCommunication, [(o) => o.selectedDate]),
            };

            setChartScores(scoresObj);
          })
          .catch((err) => {
            setChartLoading(false);
            console.log(err);
          });
      });
    };

    getBenchmarkIndustryList();
  };

  useEffect(() => {
    fetchChartData(startDate, endDate);
    // axios
    //   .get(url.findOrgById(user.profile.organizationId._id))
    //   .then(({ data }) => {
    //     orgChangeSuccess({
    //       ...data.data,
    //     });
    //   });
  }, []);

  const isApplyDisabled = () => {
    let val = true;
    if (startDate) {
      if (endDate) {
        val = false;
      }

      if (toggleChecked) {
        val = false;
      }
    }

    return val;
  };

  const handleDownload = async () => {
    const container = document.createElement("div");
    const htm = (
      <div className="my-3">
        <div className="d-flex justify-content-center align-items-center">
          <h4>{user.profile.organizationId.name}</h4>{" "}
          <div className="text-center ml-2" style={{ fontSize: "13px" }}>
            ({moment().format("MMMM DD, YYYY")})
          </div>
        </div>
      </div>
    );

    container.innerHTML = ReactDOMServer.renderToString(htm);
    const data = await document.querySelector("#jspdf_export_trends");

    container.appendChild(data.cloneNode(true));
    const options = {
      margin: [10, 10, 10, 10],
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 1 },
      jsPDF: { unit: "mm", format: "a3" },
    };
    const pdf = window
      .html2pdf()
      .set(options)
      .from(container);
    pdf.then(async () => {
      pdf.save(
        `${moment(new Date()).format(
          "dddd, MMMM Do YYYY, h:mm:ss a"
        )} - Trends.pdf`
      );
    });
  };

  const handleBechmarChangeforOrg = (data) => {
    // axios
    //   .put(url.updateOrgById(user.profile.organizationId._id), {
    //     data: { trendsBenchmarks: data },
    //   })
    //   .then(({ data }) => {
    //     orgChangeSuccess({
    //       ...user.profile.organizationId,
    //       trendsBenchmarks: data.data.trendsBenchmarks,
    //     });
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });

    const slicedData = data.slice(0, 2);

    setSelectedBenchmarks(slicedData);
    handleBenchmarkApply(chartScores, mainBList, slicedData);
  };

 const handleStartDatePicker = (id) => { 
    
    if( document.getElementById(id)){
      document.getElementById(id).click() 

    }
  
  }

  const handleEndDatePicker = (id) => { 
    if( document.getElementById(id)){
    document.getElementById(id).click() 
    }
  }

  const trendsCommonUI = () => {
    return (
      <div className="trends-common-ui">
        <div class="d-flex align-items-center mt-2 mx-5 px-5 mm-trends-top-legend">
          **Note - In the charts below, the Benchmark is in this color
          <span className="bm-color" />
          <span className="bm-color2" />
          and Your Company is in this color
          <span className="company-color" />
        </div>

        {chartloading ? (
          <div className="text-center">Loading...</div>
        ) : (
          <div className="mt-4">
            {chartScores && (
              <TrendsPlotChart
                yValues={chartScores["TOTAL"].map((x) => x.score)}
                xValues={chartScores["TOTAL"].map((x) => x.selectedDate)}
                title={"Total Score"}
                benchmarkScores={benchmarkScores.TOTAL}
                colorIndex={0}
              />
            )}

            {chartScores && (
              <div className="my-3">
                <Row className="my-3">
                  <Col sm={6} xs={12}>
                    <TrendsPlotChart
                      yValues={chartScores["SC"].map((x) => x.score)}
                      xValues={chartScores["SC"].map((x) => x.selectedDate)}
                      title={"Strategy & Commitment"}
                      colorIndex={3}
                      benchmarkScores={benchmarkScores.SC}
                    />
                  </Col>

                  <Col sm={6} xs={12}>
                    <TrendsPlotChart
                      yValues={chartScores["TD"].map((x) => x.score)}
                      xValues={chartScores["TD"].map((x) => x.selectedDate)}
                      title={"Talent Diversity"}
                      colorIndex={1}
                      benchmarkScores={benchmarkScores.TD}
                    />
                  </Col>
                </Row>

                <Row className="my-3">
                  <Col sm={6} xs={12}>
                    <TrendsPlotChart
                      yValues={chartScores["WI"].map((x) => x.score)}
                      xValues={chartScores["WI"].map((x) => x.selectedDate)}
                      title={"Workplace Inclusivity"}
                      colorIndex={4}
                      benchmarkScores={benchmarkScores.WI}
                    />
                  </Col>

                  <Col sm={6} xs={12}>
                    <TrendsPlotChart
                      yValues={chartScores["EC"].map((x) => x.score)}
                      xValues={chartScores["EC"].map((x) => x.selectedDate)}
                      title={"Engagement & Communication"}
                      colorIndex={5}
                      benchmarkScores={benchmarkScores.EC}
                    />
                  </Col>
                </Row>
              </div>
            )}
            <Popover
              placement="bottom"
              isOpen={openFilterMenu}
              toggle={() => setOpenFilterMenu(false)}
              target="trends_kk"
              style={{ width: "420px" }}
              className="trends-date-select"
            >
              <PopoverBody style={{ width: "400px" }}>
                <div className="">
                  <span className="dbFilterLabel">Choose filters</span>
                  <div className="dateFilterContainer">
                    <span
                      className="dashboardDateOptions"
                      onClick={() => setOpenFilterMenu(false)}
                    >
                      {" "}
                      {"< "}Back{" "}
                    </span>
                  </div>
                  <div style={{ display: "flex", gap: "5px" }}>
                    <div className="inner-addon right-addon">
                      <span
                        className="tool-start-date flaticon-calendar"
                        onClick={() =>
                         handleStartDatePicker("startDatePicker")
                        }
                      />
                      <ReactDatePicker
                        id="startDatePicker"
                        className="input-custom-date form-control"
                        selectsStart
                        selected={startDate ? moment(startDate).local() : null}
                        onChange={(date) =>
                          setStartDate(formatDate(date))
                        }
                        endDate={endDate ? moment(endDate).local() : null}
                        startDate={startDate ? moment(startDate).local() : null}
                        // minDate={moment()}
                        maxDate={endDate ? moment(endDate).local() : null}
                        showYearDropdown
                      />
                    </div>
                    to
                    <div className="inner-addon right-addon">
                      <span className="tool-end-date">
                        <span
                          className="flaticon-calendar"
                          onClick={() =>
                            handleEndDatePicker("endDatePicker")
                          }
                        />
                      </span>
                      <ReactDatePicker
                        id="endDatePicker"
                        className="input-custom-date form-control"
                        selectsEnd
                        selected={endDate ? moment(endDate).local() : null}
                        onChange={(date) =>
                          setEndDate(formatDate(date))
                        }
                        startDate={startDate ? moment(startDate).local() : null}
                        endDate={endDate ? moment(endDate).local() : null}
                        minDate={
                          startDate ? moment(startDate).local() : moment()
                        }
                        maxDate={moment()}
                        showYearDropdown
                      />
                    </div>
                  </div>

                  <div className="mt-3">
                    <div className="d-flex mr-4">
                      <Button
                        disabled={isApplyDisabled()}
                        color="primary"
                        onClick={() => fetchChartData(startDate, endDate)}
                      >
                        Apply
                      </Button>
                      <Button
                        className="ml-2"
                        color="danger"
                        onClick={() => {
                          setStartDate(null);
                          setEndDate(null);
                          fetchChartData(null, null);
                        }}
                      >
                        Clear
                      </Button>
                    </div>
                  </div>
                </div>
              </PopoverBody>
            </Popover>
          </div>
        )}
      </div>
    );
  };

  return (
    <div>
      <div className="d-flex align-items-center mt-3 mx-3">
        <Alert color="info" className="mb-0 py-2 d-flex align-items-center">
          <div
            className="cursor-pointer"
            style={{ display: "flex", gap: "5px", alignItems: "center" }}
            id={"trends_kk"}
            onClick={() => setOpenFilterMenu(true)}
          >
            <b>Workplace Assessment trends for</b>
            {startDate ? (
              <span>
                {" "}
                {moment(startDateDisplay).format("MMM DD, YYYY")} -{" "}
              </span>
            ) : (
              ""
            )}{" "}
            {endDate ? (
              <span>{moment(endDateDisplay).format("MMM DD, YYYY")} </span>
            ) : toggleChecked ? (
              moment().format("MMM DD, YYYY")
            ) : (
              ""
            )}{" "} <span className="card-link">(edit)</span>
          </div>
        </Alert>

        <div className="ml-2" style={{ minWidth: "250px" }}>
          <Select
            options={benchmarkList.filter((x) => !x.isDeleted)}
            onChange={(x) => {
              handleBechmarChangeforOrg(x.map((y) => y.value));
            }}
            multi
            value={selectedBenchmarks}
            placeholder="Add benchmarks"
          />
        </div>
        <span style={{color:"#3b3c419c"}} className="pl-2">(Up to 2)</span>

        <Button
          className="mr-0 ml-auto p-1"
          outline
          onClick={() => handleDownload()}
        >
          <BiDownload size={25} />
        </Button>

        {/* <div className="mm-snapshot-menu-container mr-0">
          <UncontrolledDropdown className="ml-2">
            <DropdownToggle caret className="button-8">
              Actions <IoMenu size={"22px"} />
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={() => handleDownload()}>
                Download Trends
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div> */}
      </div>

      <div>
        <div id="jspdf_export_trends">{trendsCommonUI()}</div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrendsTab);
